import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import { InvoiceReviewSummaryService } from "../../../core/services/invoice-review-summary.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ActivatedRoute } from "@angular/router";
import { InvoiceReviewInvoiceEmailsComponent } from "../invoice-review-invoice-emails/invoice-review-invoice-emails.component";
import { InvoiceReviewOrderNotesComponent } from "../invoice-review-order-notes/invoice-review-order-notes.component";
import { v4 as uuidv4 } from "uuid";
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";
import * as FileSaver from "file-saver";
import { GetBillingDetailsForEmailsDto } from "../../../core/models/invoice-review/getBillingDetailsForEmailsDto";
import { GetInvoiceReviewHeaderBillingDetailsResponse } from "../../../core/models/invoice-review/getInvoiceReviewHeaderBillingDetailsResponse";
import {
  IRSalesOrderLines,
  GetIRSalesOrderLinesResponse,
} from "../../../core/models/invoice-review/getInvoiceReviewSalesOrderLinesResponse";
import { InvoiceReviewDetailDto } from "../../../core/models/invoice-review/InvoiceReviewDetailDto";
import { OrderNotes } from "../../../core/models/invoice-review/orderNotes";
import { ProjectInvoicePrintReviewReportRequestDto } from "../../../core/models/invoice-review/projectInvoicePrintReviewReportRequestDto";
import { UpdateIRBillingReviewStatusRequestDto } from "../../../core/models/invoice-review/updateIRBillingReviewStatusRequestDto";
import { UpdateIRBillingReviewStatusResponseDto } from "../../../core/models/invoice-review/updateIRBillingReviewStatusResponseDto";
import { InvoiceEmail } from "../../../core/models/orders/invoicedEmail";
import { PrintPurchaseOrderDto } from "../../../core/models/orders/purchaseOrderLine";
import { SalesOrderNotes } from "../../../core/models/orders/salesOrderNotes";
import { VendorInvoiceJournalDetailValue } from "../../../core/models/orders/vendorInvoiceJournalDetailValue";
import { GetUserDto } from "../../../core/models/users/users/getUserDto";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { OrderNotesSidebarComponent } from "../../orders/components/order-notes-sidebar/order-notes-sidebar.component";
import { MsalApiService } from "../../../core/services/msal-api.service";
import { SidebarService } from "../../../core/services/sidebar.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ApprovalStatus } from "../../../core/models/invoice-review/approvalStatus";
import { FreightTrackingsDetailValue } from "../../../core/models/invoice-review/FreightTrackingsDetailValue";
import { CommonModule } from "@angular/common";
import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";
import { PanelModule } from "primeng/panel";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { PrintPurchaseOrderComponent } from "../../orders/components/print-purchase-order/print-purchase-order.component";
import { InvoiceReviewOrderDetailsComponent } from "../invoice-review-order-details/invoice-review-order-details.component";
import { FormsModule } from "@angular/forms";
import { InvoiceReviewOrderLineDetailsComponent } from "../invoice-review-order-line-details/invoice-review-order-line-details.component";
import { InvoiceReviewOrderTrackingComponent } from "../invoice-review-order-tracking/invoice-review-order-tracking.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { RadioButtonModule } from "primeng/radiobutton";
import { ToggleSwitchModule } from "primeng/toggleswitch";

@UntilDestroy()
@Component({
  selector: "jni-invoice-review-summary",
  templateUrl: "./invoice-review-summary.component.html",
  styleUrls: ["./invoice-review-summary.component.scss"],
  imports: [
    CommonModule,
    CheckboxModule,
    PanelModule,
    ModalStackerComponent,
    NgxExtendedPdfViewerModule,
    PrintPurchaseOrderComponent,
    OrderNotesSidebarComponent,
    InvoiceReviewOrderDetailsComponent,
    FormsModule,
    InvoiceReviewOrderLineDetailsComponent,
    InvoiceReviewOrderNotesComponent,
    InvoiceReviewOrderTrackingComponent,
    InvoiceReviewInvoiceEmailsComponent,
    ButtonModule,
    CardModule,
    InputTextModule,
    RadioButtonModule,
    ToggleSwitchModule,
  ],
})
export class InvoiceReviewSummaryComponent implements OnInit, OnDestroy {
  @Input() saleOrderId = "";
  @Input() projId = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeModalEvent = new EventEmitter();

  copyBacEmail = "";
  copyBcEmail = "";
  copyEmail = "";
  defaultTracking = "3";
  defaultLine = 0;
  reportBase64String = "";
  quickQuote = "";
  customerPONumber = "";
  jobName = "";
  shippingMethodCode = "";
  updateIpStatus = true;
  isCollapsed = false;
  vendorInvoiceJournalDetail: VendorInvoiceJournalDetailValue[] = [];
  unmatchQuantityStatus = false;
  pdfZoom = "70";
  includeNetOnlyToggle = false;
  invoiceReviewStatus: ApprovalStatus[] = [
    {
      id: "Open",
      name: "Open",
    },
    {
      id: "Approved",
      name: "Approved",
    },
    {
      id: "ApproveSplitPending",
      name: "Approve Split Pending",
    },
    {
      id: "WrongCosts",
      name: "Wrong Costs",
    },
    {
      id: "WrongSell",
      name: "Wrong Sell",
    },
    {
      id: "WrongTax",
      name: "Wrong Tax",
    },
    {
      id: "WrongFreight",
      name: "Wrong Freight",
    },
    {
      id: "WrongOther",
      name: "Wrong Other",
    },
  ];

  defaultInvoiceReviewStatus = false;
  displaySideBeforeSubmittingStatus = false;
  showPdfViewer = true;
  printPdfModal = false;
  openPrinfPdfFlag = false;
  invoiceReviewModalStatus = true;
  orderTrackingModalStatus = false;
  orderLinesDetailModalStatus = false;

  orderNotesGridListing: OrderNotes[] = [];
  orderLineDetailsGridListing: IRSalesOrderLines[] = [];
  orderLineDetailsGridListingAllData: IRSalesOrderLines[] = [];
  orderLineDetailsGridListingFilters: IRSalesOrderLines[] = [];
  invoiceReviewLines: GetIRSalesOrderLinesResponse =
    {} as GetIRSalesOrderLinesResponse;
  orderTrackingGridListing: FreightTrackingsDetailValue[] = [];
  invoiceEmailListing: InvoiceEmail[] = [];
  invoiceReviewSummary!: InvoiceReviewDetailDto;
  purchaseOrderLine: PrintPurchaseOrderDto[] = [];

  billingDetailsForEmails: GetBillingDetailsForEmailsDto =
    {} as GetBillingDetailsForEmailsDto;

  userInfo: GetUserDto = {} as GetUserDto;

  collapseNotesStatus = true;
  expandNotesStatus = false;
  collapseNotesHeading = "Collapse all";

  collapseOrderLineDetailsStatus = true;
  expandOrderLineDetailsStatus = false;
  collapseOrderLineDetailsHeading = "Collapse all";

  collapseOrderTrackingStatus = true;
  expandOrderTrackingStatus = false;
  collapseOrderTrackingHeading = "Collapse all";

  collapseInvoiceEmailStatus = true;
  expandInvoiceEmailStatus = false;
  collapseInvoiceEmailHeading = "Collapse all";
  clientName = "";
  freightChargesDisplayModal = false;
  showLessOrderLinesSection = false;

  @ViewChild("invoiceEmail", { static: false })
  invoiceEmail!: InvoiceReviewInvoiceEmailsComponent;

  @ViewChild("ordernotessidebar", { static: false })
  ordernotessidebar!: OrderNotesSidebarComponent;

  @ViewChild("ordernotes", { static: false })
  ordernotes!: InvoiceReviewOrderNotesComponent;

  orderLineDetailsConsumesMessage = "Please wait loading lines";
  updateIRBillingReviewStatusResponseDto!: UpdateIRBillingReviewStatusResponseDto;
  getInvoiceReviewHeaderBillingDetailsResponse!: GetInvoiceReviewHeaderBillingDetailsResponse;

  submitButtonColor = "blue";
  submitButtonLabel = "Submit";
  submitButtonDisabled = true;

  constructor(
    private _invoiceReviewSummaryService: InvoiceReviewSummaryService,
    private _loaderService: LoaderService,
    private _toastrService: JniToastrService,
    private _activatedRoute: ActivatedRoute,
    private renderer: Renderer2,
    private _orderSummaryService: OrderSummaryService,
    private _msalApisService: MsalApiService,
    private _dataService: SidebarService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.saleOrderId = params["id"];
      this.projId = params["projId"];
    });
  }

  ngOnInit(): void {
    this.getOrderLineDetails();
    this.getOrderTrackingDataAgainstSaleOrder();
    this.getNotesStateOfCollapseAll();
    this.getOrderLineDetailsStateOfCollapseAll();
    this.getOrderTrackingStateOfCollapseAll();
    this.getInvoiceEmailStateOfCollapseAll();
    this.getMyProfile();
    this.getInvoiceEmail(this.saleOrderId);
    this.getSalesOrderNotes(this.saleOrderId);
    this.getProjectInvoicePrintReviewReport();
    this.getInvoiceReviewHeaderBillingDetails();
    if (window.outerWidth < 1400) {
      this.pdfZoom = "50";
    }
    this._dataService.setSidebarState(!this.isCollapsed);
  }

  getSalesOrderNotes(saleOrderId: string) {
    this._loaderService.setLoaderState(true);
    this._invoiceReviewSummaryService
      .getSalesOrderNotes(saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.orderNotesGridListing = res.data;
            this.ordernotes.getAllLinePoNumber(this.saleOrderId);
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getOrderLineDetails() {
    this._loaderService.setLoaderState(true);
    this._invoiceReviewSummaryService
      .getIRSalesOrderLines(this.saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data && res.status?.toLowerCase() === "success") {
            this.invoiceReviewLines = res.data;
            if (
              this.invoiceReviewLines?.Lines &&
              this.invoiceReviewLines?.Lines?.length > 0
            ) {
              this.orderLineDetailsGridListingAllData =
                this.invoiceReviewLines.Lines ?? null;
              if (this.orderLineDetailsGridListingAllData.length > 12)
                this.orderLineDetailsGridListing =
                  this.orderLineDetailsGridListingAllData.slice(0, 12);
              else {
                this.orderLineDetailsGridListing =
                  this.orderLineDetailsGridListingAllData;
              }
              this.orderLineDetailsGridListingFilters =
                this.orderLineDetailsGridListing;
            } else {
              this.orderLineDetailsConsumesMessage = "No order line found.";
            }

            // for (const item of this.orderLineDetailsGridListing) {
            //   if (item.salesOrderNumber) {
            //     this.saleOrderId = item.salesOrderNumber;
            //     this.getSalesOrderNotes(this.saleOrderId);
            //     this._invoiceReviewOrderLineDetailsService.onSalesIdSelection({
            //       SalesId: this.saleOrderId,
            //       ProjId: item.projId
            //     });
            //     break;
            //   }
            // }
            this.includeNetOnlyLines({ checked: this.includeNetOnlyToggle });
          } else {
            this.orderLineDetailsConsumesMessage = "No order line found.";
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this.orderLineDetailsConsumesMessage =
            "There is some error while fetching records.";
        },
      });
  }

  printPdfByPurchaseOrderId(purchaseOrderId: string) {
    this._loaderService.setLoaderState(true);
    this._orderSummaryService.printPOForSalesOrder(purchaseOrderId).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.reportBase64String = res.data;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  onPdfView() {
    if (this.reportBase64String) {
      const blob = this.b64toBlob(this.reportBase64String, "application/pdf");
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    }
  }

  getProjectInvoicePrintReviewReport() {
    const reportObject = {
      SalesOrderId: this.saleOrderId,
    } as ProjectInvoicePrintReviewReportRequestDto;

    this._invoiceReviewSummaryService
      .GetProjectInvoicePrintReviewReport(reportObject)
      .subscribe({
        next: res => {
          if (res.data) {
            this.reportBase64String = res.data.reportBase64String;
          }
        },
        error: () => {
          // ToDo Log the error
        },
      });
  }

  openSideBarForOrderNotesBeforeSubmittingStatus() {
    this.displaySidebar = true;
    this.displaySideBeforeSubmittingStatus = true;
    this.ordernotessidebar.getAllLinePoNumber(this.saleOrderId);
    this.ordernotessidebar?.clearOrderNoteForm();
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  vendorInvoiceSelection() {
    for (const item of this.purchaseOrderLine) {
      this.openPdfScreen(item?.purchaseOrderNumber || "");
    }
  }

  openPdfScreen(purchaseOrderId: string) {
    const url = `/orders/po-email/${this.saleOrderId}/${purchaseOrderId}`;
    window.open(url, "_blank");
  }

  getPurchaseOrderLine() {
    this._loaderService.setLoaderState(true);
    this._invoiceReviewSummaryService
      .getPurchaseOrderLine(this.saleOrderId)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this.purchaseOrderLine = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getInvoiceEmail(saleOrderId: string) {
    this.invoiceEmailListing = [];
    this._loaderService.setLoaderState(true);
    this._invoiceReviewSummaryService
      .getInvoiceEmail(saleOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            if (res.data) {
              if (res.data.length > 0) {
                res.data.forEach(x => {
                  if (x.invoice) {
                    this.invoiceEmailListing.push(x);
                  }
                });
              }
            }
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  onNotesToggle() {
    if (this.expandNotesStatus) {
      this.collapseNotesStatus = true;
      this.expandNotesStatus = false;
      this.setNotesStateOfExpandAll();
      this.collapseNotesHeading = "Collapse all";
    } else {
      this.collapseNotesStatus = false;
      this.expandNotesStatus = true;
      this.setNotesStateOfCollapseAll();
      this.collapseNotesHeading = "Expand all";
    }
  }

  setNotesStateOfExpandAll() {
    localStorage.setItem("Invoice-Review-Notes-collapse", "true");
  }

  setNotesStateOfCollapseAll() {
    localStorage.setItem("Invoice-Review-Notes-collapse", "false");
  }

  getNotesStateOfCollapseAll() {
    const status = localStorage.getItem("Invoice-Review-Notes-collapse");
    if (status) {
      if (status === "true") {
        this.collapseNotesStatus = true;
        this.expandNotesStatus = false;
        this.collapseNotesHeading = "Collapse all";
      } else {
        this.collapseNotesStatus = false;
        this.expandNotesStatus = true;
        this.collapseNotesHeading = "Expand all";
      }
    }
  }

  onOrderLineDetailsToggle() {
    if (this.expandOrderLineDetailsStatus) {
      this.collapseOrderLineDetailsStatus = true;
      this.expandOrderLineDetailsStatus = false;
      this.setOrderLineDetailsStateOfExpandAll();
      this.collapseOrderLineDetailsHeading = "Collapse all";
    } else {
      this.collapseOrderLineDetailsStatus = false;
      this.expandOrderLineDetailsStatus = true;
      this.setOrderLineDetailsStateOfCollapseAll();
      this.collapseOrderLineDetailsHeading = "Expand all";
    }
  }

  setOrderLineDetailsStateOfExpandAll() {
    localStorage.setItem("Order-Line-Detail-collapse", "true");
  }

  setOrderLineDetailsStateOfCollapseAll() {
    localStorage.setItem("Order-Line-Detail-collapse", "false");
  }

  getOrderLineDetailsStateOfCollapseAll() {
    const status = localStorage.getItem("Order-Line-Detail-collapse");
    if (status) {
      if (status === "true") {
        this.collapseOrderLineDetailsStatus = true;
        this.expandOrderLineDetailsStatus = false;
        this.collapseOrderLineDetailsHeading = "Collapse all";
      } else {
        this.collapseOrderLineDetailsStatus = false;
        this.expandOrderLineDetailsStatus = true;
        this.collapseOrderLineDetailsHeading = "Expand all";
      }
    }
  }

  onOrderTrackingToggle() {
    if (this.expandOrderTrackingStatus) {
      this.collapseOrderTrackingStatus = true;
      this.expandOrderTrackingStatus = false;
      this.setOrderTrackingStateOfExpandAll();
      this.collapseOrderTrackingHeading = "Collapse all";
    } else {
      this.collapseOrderTrackingStatus = false;
      this.expandOrderTrackingStatus = true;
      this.setOrderTrackingStateOfCollapseAll();
      this.collapseOrderTrackingHeading = "Expand all";
    }
  }

  setOrderTrackingStateOfExpandAll() {
    localStorage.setItem("Order-Tracking-collapse", "true");
  }

  setOrderTrackingStateOfCollapseAll() {
    localStorage.setItem("Order-Tracking-collapse", "false");
  }

  getOrderTrackingStateOfCollapseAll() {
    const status = localStorage.getItem("Order-Tracking-collapse");
    if (status) {
      if (status === "true") {
        this.collapseOrderTrackingStatus = true;
        this.expandOrderTrackingStatus = false;
        this.collapseOrderTrackingHeading = "Collapse all";
      } else {
        this.collapseOrderTrackingStatus = false;
        this.expandOrderTrackingStatus = true;
        this.collapseOrderTrackingHeading = "Expand all";
      }
    }
  }

  onInvoiceEmailToggle() {
    if (this.expandInvoiceEmailStatus) {
      this.collapseInvoiceEmailStatus = true;
      this.expandInvoiceEmailStatus = false;
      this.setInvoiceEmailStateOfExpandAll();
      this.collapseInvoiceEmailHeading = "Collapse all";
    } else {
      this.collapseInvoiceEmailStatus = false;
      this.expandInvoiceEmailStatus = true;
      this.setInvoiceEmailStateOfCollapseAll();
      this.collapseInvoiceEmailHeading = "Expand all";
    }
  }

  setInvoiceEmailStateOfExpandAll() {
    localStorage.setItem("Invoice-Email-collapse", "true");
  }

  setInvoiceEmailStateOfCollapseAll() {
    localStorage.setItem("Invoice-Email-collapse", "false");
  }

  getInvoiceEmailStateOfCollapseAll() {
    const status = localStorage.getItem("Invoice-Email-collapse");
    if (status) {
      if (status === "true") {
        this.collapseInvoiceEmailStatus = true;
        this.expandInvoiceEmailStatus = false;
        this.collapseInvoiceEmailHeading = "Collapse all";
      } else {
        this.collapseInvoiceEmailStatus = false;
        this.expandInvoiceEmailStatus = true;
        this.collapseInvoiceEmailHeading = "Expand all";
      }
    }
  }

  onReviewChange(event: boolean) {
    this.showPdfViewer = event;
    this._dataService.setSidebarState(!this.isCollapsed);
  }

  getOrderTrackingDataAgainstSaleOrder() {
    this._loaderService.setLoaderState(true);
    if (this.saleOrderId && this.projId) {
      const oDataFilter = `?$top=${this.defaultTracking}&$filter=SalesId eq '${this.saleOrderId}' and ProjId eq '${this.projId}'`;
      this._invoiceReviewSummaryService
        .getFreightTrackingLine(oDataFilter)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.orderTrackingGridListing = res.data;
            this._loaderService.setLoaderState(false);
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  closePrinfPdfModal() {
    this.printPdfModal = false;
  }

  count = 0;
  invoiceEmailAdd() {
    this.cancelAllEditRow();
    this.count++;
    const object = {
      id: 0,
      email: this.copyEmail ?? "",
      name: "",
      purpose: "",
      save: false,
      exist: false,
      confirmation: false,
      invoice: true,
      salesOrderIdD365: "",
      invoiceEmailRecIdD365: 0,
    } as InvoiceEmail;
    this.invoiceEmailListing.push(object);
    this.invoiceEmail.table.initRowEdit(
      this.invoiceEmail.table.value[this.invoiceEmail.table.value?.length - 1]
    );

    // Means its coming from the COpy BAC or BC checkbox
    // Then save it instead of showing it in editable mode to user
    if (this.copyEmail) {
      this.saveInvoiceEmailModel(object);

      //Make it empty
      this.copyEmail = "";
    }
  }

  cancelAllEditRow() {
    this.invoiceEmail.table.value.forEach(x => {
      this.invoiceEmail.table.cancelRowEdit(x);
    });
  }

  invoiceEmailDuplicate(invoicedEmail: InvoiceEmail[]): boolean {
    const email = invoicedEmail[invoicedEmail.length - 1]?.email;
    const recid =
      invoicedEmail[invoicedEmail.length - 1]?.invoiceEmailRecIdD365;
    if (!recid) {
      for (const item of this.invoiceEmailListing) {
        if (email === item.email) {
          this._toastrService.error(
            "Error",
            `Email address "${email}". The record already exists.`
          );
          return true;
        }
      }
    }
    return false;
  }

  isEmailInvoiced(invoicedEmail: InvoiceEmail): boolean {
    if (invoicedEmail.invoice) {
      return true;
    }
    return false;
  }

  isEmailValid(invoicedEmail: InvoiceEmail): boolean {
    let isEmail = true;
    const email: string = invoicedEmail.email;
    const regex = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";
    if (!RegExp(regex).exec(email)) {
      isEmail = false;
    }
    if (isEmail) {
      return true;
    }
    return false;
  }

  EmailDuplicate(invoicedEmail: InvoiceEmail[]): boolean {
    for (let i = 0; i < invoicedEmail.length; i++) {
      const email = invoicedEmail[i].email;
      for (let j = i + 1; j < invoicedEmail.length; j++) {
        if (email === invoicedEmail[j].email) {
          this._toastrService.error(
            "Error",
            `Email address "${email}". The record already exists.`
          );
          return true;
        }
      }
    }
    return false;
  }

  saveInvoiceEmailModel(invoicedEmail: InvoiceEmail) {
    if (!this.isEmailInvoiced(invoicedEmail)) {
      this._toastrService.error(
        "Error",
        "Atleast one email should be invoiced"
      );
      return;
    }

    if (!invoicedEmail.email) {
      this._toastrService.error("Error", "Email is required");
      return;
    }

    if (!this.isEmailValid(invoicedEmail)) {
      this._toastrService.error("Error", "Invalid email format");
      return;
    }

    const invoiceEmail = invoicedEmail;
    if (!invoiceEmail.invoiceEmailRecIdD365) {
      invoicedEmail.salesOrderIdD365 = this.saleOrderId;
      invoicedEmail.portalKey = uuidv4();
      const invoiceEmailArray = [];
      invoiceEmailArray.push(invoicedEmail);

      if (this.saleOrderId) {
        this._loaderService.setLoaderState(true);
        this._invoiceReviewSummaryService
          .createInvoiceEmailSaleOrderHeaderData(invoiceEmailArray)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              this.getInvoiceEmail(this.saleOrderId);
              if (res?.data?.Status?.toLowerCase() === "success") {
                this._toastrService.success(
                  "Success",
                  res.message || "Invoice email create successfully"
                );
              } else {
                this._toastrService.error(
                  "Error",
                  res.message || "Error creating invoice email"
                );
              }
            },
            error: res => {
              this._loaderService.setLoaderState(false);
              this._toastrService.error(
                "Error",
                res.message || "Error creating invoice email"
              );
            },
          });
      }
    } else {
      invoicedEmail.salesOrderIdD365 = this.saleOrderId;
      invoicedEmail.portalKey = "";
      const invoiceEmailArray = [];
      invoiceEmailArray.push(invoicedEmail);
      if (this.saleOrderId) {
        this._loaderService.setLoaderState(true);
        this._invoiceReviewSummaryService
          .updateInvoiceEmailSaleOrderHeaderData(invoiceEmailArray)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: res => {
              this.getInvoiceEmail(this.saleOrderId);
              this._loaderService.setLoaderState(false);
              if (res?.data?.Status?.toLowerCase() === "success") {
                this._toastrService.success(
                  "Success",
                  res.message || "Invoice email updated successfully"
                );
              } else {
                this._toastrService.error(
                  "Error",
                  res.message || "Error updating invoice email"
                );
              }
            },
            error: res => {
              this._loaderService.setLoaderState(false);
              this._toastrService.error(
                "Error",
                res.message || "Error updating invoice email"
              );
            },
          });
      }
    }
  }

  invoiceEmailDelete(invoicedEmail: InvoiceEmail[]) {
    this._loaderService.setLoaderState(true);
    const arrayobject: number[] = [];
    invoicedEmail?.forEach(x => {
      if (x.invoiceEmailRecIdD365 !== 0) {
        arrayobject.push(x.id);
      }
    });
    this._invoiceReviewSummaryService
      .deleteInvoiceEmailData(arrayobject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.getInvoiceEmail(this.saleOrderId);
          if (res?.data?.Status?.toLowerCase() === "success") {
            this._toastrService.success(
              "Success",
              res.message || "Invoice email delete successfully"
            );
          } else {
            this._toastrService.error(
              "Error",
              res.message || "Error deleting invoice email"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error deleting invoice email"
          );
        },
      });
  }

  invoiceEmailEdit(invoiceEmail: InvoiceEmail) {
    this.cancelAllEditRow();
    const row = this.invoiceEmail.table.value.filter(
      x => x.id === invoiceEmail.id
    );
    if (row.length > 0) {
      this.invoiceEmail.table.initRowEdit(row[0]);
    }
  }

  displaySidebar = false;

  openSideBarForOrderNotes() {
    this.displaySidebar = true;
    this.ordernotessidebar.getAllLinePoNumber(this.saleOrderId);
    this.ordernotessidebar?.clearOrderNoteForm();
  }

  updateSideBarForOrderNotes() {
    this.ordernotes.updateSingleLine();
    this.ordernotessidebar.getAllLinePoNumber(this.saleOrderId);
  }

  deleteSideBarForOrderNotes() {
    this.ordernotes.deleteSaleOrderNotes();
  }

  closeSideBarForOrderNotes() {
    this.displaySidebar = false;
    this.displaySideBeforeSubmittingStatus = false;
  }

  updateLineOnSideBar(selectedOrderNotesGridListing: OrderNotes[]) {
    if (selectedOrderNotesGridListing?.length > 0) {
      this.displaySidebar = true;
      this.ordernotessidebar?.patchValueInOrderNote(
        selectedOrderNotesGridListing[0] as unknown as SalesOrderNotes
      );
    }
  }

  onQuickQuote() {
    this._loaderService.setLoaderState(true);

    const saleOrderFormObject = {
      description: "IP-Note",
      id: 0,
      note: this.quickQuote,
      portalKey: "",
      purchaseOrderStatus: false,
      salesOrderId: "",
      type: "Billing note",
    } as SalesOrderNotes;

    if (this.saleOrderId) {
      saleOrderFormObject.salesOrderId = this.saleOrderId;
      saleOrderFormObject.portalKey = uuidv4();
    }

    this._invoiceReviewSummaryService
      .AddSalesOrderNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
          this.getSalesOrderNotes(this.saleOrderId);
          this.quickQuote = "";
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error adding order note"
          );
        },
      });
  }

  getMyProfile() {
    this._invoiceReviewSummaryService
      .GetMyProfile()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() == "success") {
            this.userInfo = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getBillingDetailsForEmails(proposalId: string) {
    this._invoiceReviewSummaryService
      .getBillingDetailsForEmails(proposalId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() == "success") {
            this.billingDetailsForEmails = res.data;
            this.sendApprovalStatusEmail(this.billingDetailsForEmails);
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error adding order note"
          );
        },
      });
  }

  sendApprovalStatusEmail(details: GetBillingDetailsForEmailsDto) {
    const toRecipients: MicrosoftGraph.Recipient[] = [
      {
        emailAddress: {
          address: details.billerEmail,
          name: details.billerEmail,
        },
      },
    ];

    if (this.copyBacEmail) {
      const obj: MicrosoftGraph.Recipient = {
        emailAddress: {
          address: this.copyBacEmail,
          name: this.copyBacEmail,
        },
      };
      toRecipients.push(obj);
    }

    if (this.copyBcEmail) {
      const obj: MicrosoftGraph.Recipient = {
        emailAddress: {
          address: this.copyBcEmail,
          name: this.copyBcEmail,
        },
      };
      toRecipients.push(obj);
    }

    const sender: MicrosoftGraph.Recipient = {
      emailAddress: {
        address: this.userInfo.sendEmailAs,
        name: this.userInfo.displayEmailAs,
      },
    };

    let mailMessage: MicrosoftGraph.Message = {};

    mailMessage = {
      subject: details.subject,
      body: {
        contentType: "html",
        content: details.html,
      },
      toRecipients: toRecipients,
      sender: sender,
    };

    const mail = {
      message: mailMessage,
    };
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  addScollHiddenClass() {
    if (this.invoiceReviewModalStatus) {
      this.renderer.addClass(document.body, "p-overflow-hidden");
    }
  }

  sellAllOrderTracking() {
    this.orderTrackingModalStatus = true;
  }

  closeModalForOrderTracking() {
    this.orderTrackingModalStatus = false;
  }

  sellAllOrderLineDetails() {
    this.showLessOrderLinesSection = true;
    this.orderLineDetailsGridListing = this.orderLineDetailsGridListingAllData;
    this.orderLineDetailsGridListingFilters =
      this.orderLineDetailsGridListingAllData;
    this.includeNetOnlyLines({ checked: this.includeNetOnlyToggle });
  }

  showLessOrderLines() {
    this.showLessOrderLinesSection = false;
    this.orderLineDetailsGridListing =
      this.orderLineDetailsGridListingAllData.slice(0, 12);
    this.orderLineDetailsGridListingFilters = this.orderLineDetailsGridListing;
    this.includeNetOnlyLines({ checked: this.includeNetOnlyToggle });
  }

  closeModalForOrderLineDetails() {
    this.orderLinesDetailModalStatus = false;
  }

  includeNetOnlyLines(obj: CheckboxChangeEvent) {
    if (obj?.checked) {
      this.includeNetOnlyToggle = true;
      this.orderLineDetailsGridListing =
        this.orderLineDetailsGridListingFilters.filter(
          x => x.Sell != null && x.Sell >= 0
        );

      if (this.orderLineDetailsGridListing.length <= 0) {
        this.orderLineDetailsConsumesMessage = "No order line found.";
      }
    } else {
      this.orderLineDetailsGridListing =
        this.orderLineDetailsGridListingFilters.filter(
          x => x.Sell != null && x.Sell > 0
        );
      if (this.orderLineDetailsGridListing.length <= 0) {
        this.orderLineDetailsConsumesMessage = "No order line found.";
      }
      this.includeNetOnlyToggle = false;
    }
  }

  redirectToFreightChargesPage() {
    this.freightChargesDisplayModal = true;
  }

  closeModalForFreight() {
    this.freightChargesDisplayModal = false;
  }

  invoiceEmailCopyBacEmailEvent(email: string) {
    this.copyBacEmail = email;
  }

  invoiceEmailCopyBcEmailEvent(email: string) {
    this.copyBcEmail = email;
  }

  invoiceEmailAddBcBacEmailEvent(email: string) {
    if (email) {
      this.copyEmail = email;
    }
  }

  submitInvoiceReviewStatus() {
    this._loaderService.setLoaderState(true);
    const request: UpdateIRBillingReviewStatusRequestDto = {
      salesOrderId: this.saleOrderId,
      isReadyForBillingReview: this.defaultInvoiceReviewStatus,
    };
    this._invoiceReviewSummaryService
      .submitInvoiceReviewStatus(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.getInvoiceReviewHeaderBillingDetails();
          this._loaderService.setLoaderState(false);
          if (res?.status?.toLowerCase() === "success") {
            if (res?.data) {
              this.updateIRBillingReviewStatusResponseDto = res.data;
              if (this.updateIRBillingReviewStatusResponseDto?.billerEmail) {
                this.sendEmailToBiller();
              }
            }
            this.getSalesOrderNotes(this.saleOrderId);
          } else {
            this.getSalesOrderNotes(this.saleOrderId);
            this._toastrService.error(
              "Error",
              res.message || "Error processing request"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastrService.error(
            "Error",
            res.message || "Error processing request"
          );
        },
      });
  }

  sendEmailToBiller() {
    const toRecipients: MicrosoftGraph.Recipient[] = [
      {
        emailAddress: {
          address: this.updateIRBillingReviewStatusResponseDto.billerEmail,
          name: this.updateIRBillingReviewStatusResponseDto.billerEmail,
        },
      },
    ];

    let mailMessage: MicrosoftGraph.Message = {};

    mailMessage = {
      subject: this.updateIRBillingReviewStatusResponseDto.subject,
      body: {
        contentType: "html",
        content: this.updateIRBillingReviewStatusResponseDto.html,
      },
      toRecipients: toRecipients,
    };

    const mail = {
      message: mailMessage,
    };
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getInvoiceReviewHeaderBillingDetails() {
    if (this.saleOrderId) {
      this._invoiceReviewSummaryService
        .getInvoiceReviewHeaderBillingDetails(this.saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data) {
              this.getInvoiceReviewHeaderBillingDetailsResponse = res.data;
              if (
                this.getInvoiceReviewHeaderBillingDetailsResponse
                  .isReadyForBillingReview
              ) {
                this.submitButtonColor = "green";
                this.submitButtonLabel = "Submitted";
                this.submitButtonDisabled = true;
                this.defaultInvoiceReviewStatus = false;
              }
            }
          },
          error: res => {
            this._toastrService.error("Error", res.message || "Data not found");
          },
        });
    }
  }

  updatePdfEvent() {
    this.getProjectInvoicePrintReviewReport();
  }

  exportExcelForOrderTracking() {
    this.exportExcelForOrderTrackingFilterData(this.orderTrackingGridListing);
  }

  exportExcelForOrderTrackingFilterData(
    filterlist: FreightTrackingsDetailValue[]
  ) {
    const object = filterlist.map(datum => {
      return {
        ["Ship Date"]: datum.ShipDate,
        ["Carrier"]: datum.Carrier,
        ["Tracking"]: datum.TrackingNumber,
        ["Weight"]: datum.Weight,
        ["Sale Price"]: datum.SellPrice,
        ["Ship Method"]: datum.DlvModeDescription,
        ["Shipper Name"]: datum.ShipperName || "",
        ["Recipient Name"]: datum.RecipientName || "",
        ["Shipped From"]: datum.ShipFromAddress,
        ["Shipped To"]: datum.ShipToAddress,
        ["Reference Fields"]: datum.JNIReference,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "InvoiceReviewOrderTracking");
    });
  }

  exportExcelForNotes() {
    this.exportExcelForOrderNotesFilterData(this.orderNotesGridListing);
  }

  exportExcelForOrderNotesFilterData(filterlist: OrderNotes[]) {
    const object = filterlist.map(datum => {
      return {
        ["Type"]: datum.type,
        ["Description"]: datum.description,
        ["Note"]: datum.note,
        ["Modified By"]: datum.lastModifiedBy,
        ["Modified Date"]: datum.lastModifiedDate,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "InvoiceReviewOrderNotes");
    });
  }

  exportExcel() {
    this.exportExcelForFilterData(this.orderLineDetailsGridListingAllData);
  }

  exportExcelForFilterData(filterlist: IRSalesOrderLines[]) {
    const object = filterlist.map(datum => {
      return {
        ["Line"]: datum.LineNum,
        ["PO#"]: datum.PurchId,
        ["Vendor"]: datum.Vendor,
        ["Description"]: datum.Description,
        ["Matched %"]: datum.MatchedPercent,
        ["UnMat"]: datum.UnmatchedQty,
        ["Qty"]: datum.Qty,
        ["Sell"]: datum.Sell,
        ["Total Sell"]: datum.TotalSell,
        ["Net"]: datum.Net,
        ["Total Cost"]: datum.TotalCost,
        ["GP"]: datum.GP,
        ["Com"]: datum.Commission,
        ["Ven Inv Date"]: datum.venInvDate,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "InvoiceReviewOrderLinesDetails");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  onCheckboxChange() {
    this.submitButtonDisabled = !this.defaultInvoiceReviewStatus;
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }
}
